import SectionTitle from '@/components/base/SectionTitle';
import DramaCard from '@/components/base/DramaCard';
import type { Drama } from '@/types/drama';

interface LatestGridProps {
  dramas: Drama[];
}

export default function LatestGrid({ dramas }: LatestGridProps) {
  return (
    <section className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
      <SectionTitle
        eyebrow="最新上线"
        title="最新伦理剧推荐"
        description="持续更新的韩国家庭与情感题材剧集，点击封面查看完整剧情介绍与解析。"
        action={{ label: '查看全部伦理剧', to: '/category/ethical-drama' }}
      />

      {dramas.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 py-16 text-center">
          <span className="mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-400">
            <i className="ri-inbox-line text-2xl" />
          </span>
          <p className="text-sm text-foreground-600">暂无最新推荐剧集</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
          {dramas.map((d, i) => (
            <DramaCard key={d.id} drama={d} index={i} />
          ))}
        </div>
      )}
    </section>
  );
}